var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeriFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.64 182.5H49.36C41.98 182.5 36 176.53 36 169.16V53.11C36 49.5 37.47 46.04 40.06 43.53L63.09 21.26C65.58 18.85 68.91 17.5 72.38 17.5H150.64C158.02 17.5 164 23.47 164 30.84V169.17C164 176.54 158.02 182.51 150.64 182.51V182.5Z",
    fill: "white",
    stroke: "#D21C1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.45 98.8L124.54 118.93H106.71C105.8 117.11 104.12 114.45 101.68 110.95L100.03 108.58C99.74 109.01 99.42 109.47 99.06 109.95C98.7 110.43 98.35 110.96 98.02 111.53C97.06 112.87 96.16 114.19 95.33 115.48C94.49 116.77 93.81 117.92 93.28 118.93H75.45L90.54 98.8L76.02 79.68H93.77C94.44 81.02 95.73 83.11 97.65 85.93L100.02 89.52L102.03 86.43C104.04 83.41 105.43 81.16 106.2 79.67H123.95L109.43 98.79L109.45 98.8Z",
    fill: "#D21C1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeriFail);
export default __webpack_public_path__ + "static/media/veri_fail.b33d796e77ed929da4ce7954e23bb431.svg";
export { ForwardRef as ReactComponent };